export default "__VITE_ASSET__9d0d6146__"